import React from "react";
import styled from "styled-components";
import { Formik } from "formik";
import { Grid } from "@material-ui/core";
import Button from "ui/components/Button";

const Container = styled.div`
  padding: 5rem;
`;

const Test = (props) => {
  const [sending, setSending] = React.useState(false);

  const [status, setStatus] = React.useState();
  const [error, setError] = React.useState();

  const setCookie = ({ name, value, days }) => {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = "; expires=" + date.toGMTString();

    document.cookie = `${name}=${value}; path=/; domain=${window.insentCompanyDomain}; ${expires}; samesite=strict; secure;`;
  };

  const submitConditions = (values) => {
    let url = "https://insentdev.api.insent.ai/datapopulate/user?";

    let params = "";
    if (values.email && values.email.length) {
      params += `email=${values.email}`;
    }
    if (values.qualification && values.qualification.length) {
      params += `&qualification=${values.qualification}`;
    }
    if (values.account && values.account.length) {
      params += `&account=${values.account}`;
    }
    if (values.time >= 0) {
      params += `&timespent=${values.time}&timespentop=${values.timeop}`;
    }
    if (values.visit >= 0) {
      params += `&visits=${values.visit}&visitop=${values.visitop}`;
    }
    if (values.url && values.url.length) {
      params += `&urls=${values.url}`;
    }
    if (values.exclude && values.exclude.length) {
      params += `&excludevisitors=${JSON.stringify(values.exclude.split(","))}`;
    }

    if (values.returnvisitor && values.returnvisitor.length) {
      params += `&returnvisitor=${values.returnvisitor}`;
    }

    if (params && params.length) {
      url += params;
    }
    console.log("params: ", params);

    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };

    setSending(true);
    setStatus('');
    setError("Caling api ...");

    fetch(url, {
      method: "GET",
      headers: header,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        setError('');

        setSending(false);
        setStatus(data);

       
      })
      .catch(function (error) {
        setSending(false);
        setError("Error - " + error);
      });
  };

  const renderStatus = () => { 
    console.log("status", status)
    return (
      <>
      <br />
      <Grid container>
            <Grid item xs={2}>
              Name
            </Grid>
            <Grid item xs={2}>
              Email
            </Grid>
            <Grid item xs={3}>
              Id
            </Grid>
            <Grid item xs={3}>
              
            </Grid>
          </Grid>
      {status.map((data, index) => {

        return (
          <>
          <Grid container className="d-flex align-items-center my-auto">
            <Grid item xs={2}>
              {data.firstName} {data.lastName}
            </Grid>
            <Grid item xs={2}>
              {data.email}
            </Grid>
            <Grid item xs={3}>
              {data.visitorId}
            </Grid>
            <Grid item xs={2}>
              <Button onClick={() => {
                 if (data.visitorId) {
                  setCookie({
                    name: "insent-user-id",
                    value: data.visitorId,
                    days: 730,
                  });
                }
                setStatus('');
                setError('Cookie is added');
              }}> SET </Button>
            </Grid>
          </Grid>
          <br />
          </>
        )

      })}
      </>
    );

  }

  const getToken = (e) => {
    let tokenValue = e.target.token.value;
    if(tokenValue){
      localStorage.setItem("token", tokenValue);
    }
    e.preventDefault();
  } 

  return (
    <Container>
      <br />

      <form onSubmit={ e=> getToken(e)}>
        <label for="token">Token</label>
        <br />
        <input autoComplete="off" type="text" id="token" name="token" style={{ width: '75%'}} defaultValue={localStorage.getItem('token')} />
        <br />
        <br />

        <Button type="submit">Add token</Button>
      </form>

      <br />
      <br />
      <h3>Get users by email</h3>
      <br />

      <Formik
        validate={(values) => {
          let errors = {};

          return errors;
        }}
        initialValues={{
          email: ''
        }}
        onSubmit={submitConditions}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
             <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Email id</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  placeholder="Email id"
                />
              </Grid>
            </Grid>
            {/* <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Account Name</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="text"
                  name="account"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.account}
                  placeholder="Account Name"
                />
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Time spent in seconds</div>
              </Grid>
              <Grid item xs={3}>
                <select
                  name="timeop"
                  value={values.timeop}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <option value="eq">Equal To</option>
                  <option value="gt">Greater Than</option>
                  <option value="lt">Less Than</option>
                </select>
              </Grid>
              <Grid item xs={5}>
                <input
                  type="number"
                  min="0"
                  name="time"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.time}
                  placeholder="Time spent"
                />
              </Grid>
            </Grid>

            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Number of visits</div>
              </Grid>
              <Grid item xs={3}>
                <select
                  name="visitop"
                  value={values.visitop}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <option value="eq">Equal To</option>
                  <option value="gt">Greater Than</option>
                  <option value="lt">Less Than</option>
                </select>
              </Grid>
              <Grid item xs={5}>
                <input
                  type="number"
                  min="0"
                  name="visit"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.visit}
                  placeholder="Visits count"
                />
              </Grid>
            </Grid>

            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Url</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.url}
                  name="url"
                  placeholder="Url"
                />
              </Grid>
            </Grid>

            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Exclude Users</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.exclude}
                  name="exclude"
                  placeholder="Users id separated with comma"
                />
              </Grid>
            </Grid>

            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Qualification</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="radio"
                  name="qualification"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={"qualifiedwithappuser"}
                />{" "}
                Qualified with agent assigned
                <br />
                <input
                  type="radio"
                  name="qualification"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={"qualified"}
                />{" "}
                Qualified without agent assigned
                <br />
                <input
                  type="radio"
                  name="qualification"
                  onChange={handleChange}
                  defaultChecked={true}
                  onBlur={handleBlur}
                  value={"notqualified"}
                />{" "}
                Not qualified
              </Grid>
            </Grid>

            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div>Return Visitor</div>
              </Grid>
              <Grid item xs={8}>
                <input
                  type="radio"
                  name="returnvisitor"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={"withaccount"}
                />{" "}
                With account
                <br />
                <input
                  type="radio"
                  name="returnvisitor"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={"withoutaccount"}
                />{" "}
                Without account
                <br />
                <input
                  type="radio"
                  name="returnvisitor"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={"any"}
                />{" "}
                Any
              </Grid>
            </Grid> */}
            <br />
            {sending ? (
              <Button disabled>Sending ... </Button>
            ) : (
              <Button type="submit">Submit</Button>
            )}
          </form>
        )}
      </Formik>

      <br />
      <br />
      <hr />
      <h3>Status</h3>
 
          {status && status.length && <div>{renderStatus()}</div>}
          {error && error.length && <div>{error}</div>}
    </Container>
  );
};

Test.propTypes = {};

export default Test;
